<template>
	<openerComponent
		componentTitle="Selling Bellingen properties with you every step of the way."
		componentBgColor="#e8e7e3"
		:componentImage="image"
		showOverlay=false
		showCallout=true
		showAlternateContent=false
	/>
	<xmasComponent v-if="showComponent"/>
	<aboutComponent />
	<listingsComponent />
	<reviewsComponent />
	<connectionsComponent />
	<callToActionComponent />
	<footerComponent />
	<copyrightComponent />
</template>

<script>

	// load components
	import openerComponent from "../components/global/opener.vue";
	import aboutComponent from "../components/home/office-intro.vue";
	import listingsComponent from "../components/home/listings.vue";
	import reviewsComponent from "../components/home/reviews.vue";
	import connectionsComponent from "../components/home/connections.vue";
	import callToActionComponent from "../components/global/callToAction.vue";
	import footerComponent from "../components/global/footerComponent.vue";
	import copyrightComponent from "../components/global/copyright.vue";
	import xmasComponent from "../components/home/xmas.component.vue"

	// load assets
	import bgImage from "../assets/opener-image.jpg"


	export default({
		name: "homepage Component",
		components: {
			openerComponent,
			aboutComponent,
			listingsComponent,
			reviewsComponent,
			connectionsComponent,
			callToActionComponent,
			footerComponent,
			copyrightComponent,
			xmasComponent
		},
		data() {
			return {
				image: bgImage,
				showComponent: false
			}
		}
	});
</script>